var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 48,
    viewBox: "0 0 54 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9904 37.2441L16.6139 47.6206H37.3668L26.9904 37.2441Z",
    fill: "#1F2024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.446 24.4061L26.9904 0.950439V9.22265L46.3147 28.547C48.5444 30.7767 48.5444 34.4061 46.3147 36.6358C44.085 38.8656 40.4556 38.8656 38.2259 36.6358L26.9904 25.4003L15.7548 36.6358C13.5251 38.8656 9.89574 38.8656 7.66601 36.6358C5.43627 34.4061 5.43627 30.7767 7.66601 28.547L20.8707 15.3424L40.1274 34.5991C41.2664 35.7381 43.1294 35.7961 44.2587 34.7246C44.8379 34.1744 45.1661 33.4312 45.1757 32.6397C45.1854 31.8385 44.8861 31.0953 44.3166 30.5258L20.8803 7.06049L3.53473 24.4061C-0.973001 28.9138 -0.973001 36.2594 3.53473 40.7671C5.7162 42.9486 8.6216 44.1551 11.7104 44.1551C14.7992 44.1551 17.7046 42.9486 19.8861 40.7671L26.9807 33.6725L34.0753 40.7671C36.2568 42.9486 39.1622 44.1551 42.251 44.1551C45.3398 44.1551 48.2452 42.9486 50.4267 40.7671C52.6082 38.5856 53.8147 35.6802 53.8147 32.5914C53.8147 29.5026 52.6082 26.5972 50.4267 24.4157L50.446 24.4061Z",
    fill: "#1F2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/default_logo.146e467a923654842fa6b57a667957d5.svg";
export { ForwardRef as ReactComponent };